import { render, staticRenderFns } from "./ImgPayPal.vue?vue&type=template&id=f922c4a0&scoped=true&"
import script from "./ImgPayPal.vue?vue&type=script&lang=js&"
export * from "./ImgPayPal.vue?vue&type=script&lang=js&"
import style0 from "./ImgPayPal.vue?vue&type=style&index=0&id=f922c4a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f922c4a0",
  null
  
)

export default component.exports